import { createAsyncThunk } from "@reduxjs/toolkit";
import { APP_PATH } from "../../api/backendPath";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

import i18n from "../../i18n";
// Fetch earnings summary metrics
export const fetchEarningsSummaryReducer = createAsyncThunk(
  "earnings/fetchEarningsSummary",
  async (_ = {}, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const fullUrl = `${process.env.REACT_APP_API_URL}${APP_PATH.nurseEarningsSummary}`;
      const response = await axiosPrivate.get(fullUrl);
      if (response?.data?.status === true || response?.status === 200) {
        return response.data.data;
      }
      return rejectWithValue(response?.data?.message || i18n.t("toast.failedToFetchEarningsSummary"));
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || i18n.t("toast.errorFetchingEarningsSummary"),
      );
    }
  }
);

// Fetch earnings list
export const fetchEarningsListReducer = createAsyncThunk(
  "earnings/fetchEarningsList",
  async (
    { search = "", paymentStatus = "", location = "", startDate = "", endDate = "", page = 1, limit = 10 } = {},
    { rejectWithValue },
  ) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const queryParamsObj = { page: String(page), limit: String(limit) };
      if (search) queryParamsObj.search = search;
      if (paymentStatus && paymentStatus !== "All") queryParamsObj.paymentStatus = paymentStatus;
      if (location && location !== "All") queryParamsObj.location = location;
      if (startDate) queryParamsObj.startDate = startDate;
      if (endDate) queryParamsObj.endDate = endDate;
      const queryParams = new URLSearchParams(queryParamsObj).toString();
      const fullUrl = `${process.env.REACT_APP_API_URL}${APP_PATH.nurseEarnings}?${queryParams}`;
      const response = await axiosPrivate.get(fullUrl);
      if (response?.data?.status === true || response?.status === 200) {
        return response.data.data;
      }
      return rejectWithValue(response?.data?.message || i18n.t("toast.failedToFetchEarnings"));
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || i18n.t("toast.errorFetchingEarnings"),
      );
    }
  }
);
